import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  PlanMenusDto,
  PlanType,
  UpdatePlanCommand,
} from 'src/app/core/api/models';
import { PlansService } from 'src/app/core/api/services/plans.service';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { DialogService } from 'src/app/core/services/dialog.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { CustomClaimDto } from 'src/app/pages/system-management/roles/models/custom-claim-dto';
import { DateTimeConfig } from '../../../../shared/components/date-time-picker/date-time-picker.component';
import { CreatePlanCommand } from './../../../../core/api/models/create-plan-command';
import { EventTypes } from './../../../../core/constants/event-types';
import { DialogStatus } from './../../../../core/services/dialog.service';

@Component({
    selector: 'app-plans-management-form',
    templateUrl: './plans-management-form.component.html',
    styleUrls: ['./plans-management-form.component.scss'],
    standalone: false
})
export class PlansManagementFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  protected currentService = inject(PlansService);
  formPageConfig: FormPageConfig<PlanMenusDto> = {};
  model: CreatePlanCommand = {};
  get PlanType() {
    return PlanType;
  }
  dateTimeConfig: DateTimeConfig;
  @Input() menus: Array<CustomClaimDto> = [];
  @Input() selectedMenuIds: Array<number> = [];

  //#endregion

  constructor(
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.plans);
    }
  }

  initModel() {
    super.initModel();
    if (this.formPageConfig.isEditMode) {
      this.selectedMenuIds = this.formPageConfig.editData.menuIds;
      this.menus = this.formPageConfig.editData.menusClaims;
      this.onChangeType(this.model.planType);
    }
    this.setComponentsConfig();
  }

  setComponentsConfig() {
    try {
      this.dateTimeConfig = {
        dateLabel: 'common.expireDate',
        timeLabel: 'common.expireTime',
        dateFormControl: this.form?.get('expireDate') as FormControl,
        timeFormControl: this.form?.get('expireTime') as FormControl,
        minDateType: 'today',
        isDefaultValue: false,
        responsiveClassName: 'md:tw-w-full',
        isConvertToIsoString: false,
        dateTimeValue: this.model.expirationTime,
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.plans);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      planType: new FormControl('', Validators.required),
      expireDate: new FormControl('', Validators.required),
      expireTime: new FormControl('', Validators.required),
      isDefault: new FormControl(),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePlanCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .plansCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePlanCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;
    this.currentService
      .plansUpdatePut({ id: this.formPageConfig.editId, body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);

    //  this.formPageConfig.isEditMode = false;
  }

  //#endregion

  isValidMenuIds(): boolean {
    if (!this.model.menuIds.length) {
      this.dialogService.openDialog({
        title: 'common.error',
        message: 'messages.notSelectAnyMenu',
        status: DialogStatus.error,
      });

      return false;
    }
    return true;
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      if (!this.isValidMenuIds) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.plans);
    }
  }

  onChangeType(type: PlanType) {
    this.model.planType = type;
    if (type == PlanType.Module) {
      this.form.get('expireDate').clearValidators();
      this.form.get('expireTime').clearValidators();
    } else {
      this.form.get('expireDate').setValidators([Validators.required]);
      this.form.get('expireTime').setValidators([Validators.required]);
    }
    this.form.get('expireDate').updateValueAndValidity();
    this.form.get('expireTime').updateValueAndValidity();
  }
}
